import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import Employee from '../js/employee';
export default (function ($prop, ctx) {
  var eventName = ctx.$f7route.params.eventName;
  var popupcln = 'div[data-name="employee-list-popup"]';
  var popup;
  var rows = [];

  var updateDom = function updateDom() {
    ctx.$update(function () {
      $(popupcln + ' .emp-list li a').click(function (e) {
        var data = $(e.target).closest('a').dataset();
        Base.app.emit(eventName, data);
        popup.close();
      });
    });
  };

  if (Employee.rows === null) {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Employee.list();

            case 2:
              rs = _context.sent;
              rows = rs.rows;
              updateDom();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  } else {
    rows = Employee.rows;
    updateDom();
  }

  var filterEmployeeList = function filterEmployeeList(value) {
    //Lưu giá trị đã chọn
    Base.lastSelectedFilteredEmpListValue = value || '';

    if (value === '') {
      //Hiển thị tất cả
      $(popupcln + ' .emp-list li').removeClass('display-none');
      return;
    } //Nếu value !== '' thì
    //Ẩn hết tất cả trước


    $(popupcln + ' .emp-list li').addClass('display-none'); //Sau đó thì tìm đến các li phù hợp để hiển thị lên

    $(popupcln + " .emp-list li a").each(function () {
      if ($(this).attr("data-".concat(value)) === '1') {
        $(this).parent().removeClass('display-none');
      }
    });
  };

  ctx.$on('popup:open', function (e) {
    popup = e.target.f7Modal;
    var $selectedFiltered = $(e.target).find('select[name="filter-select"]');
    $selectedFiltered.change(function (e) {
      filterEmployeeList($(e.target).val());
    });
    $selectedFiltered.val(Base.lastSelectedFilteredEmpListValue || ''); //Hiển thị danh sách theo filter đã chọn

    filterEmployeeList(Base.lastSelectedFilteredEmpListValue);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup" data-name="employee-list-popup">
    <div class="view">
      <div class="page">
        <div class="navbar">
          <div class="navbar-bg"></div>
          <div class="navbar-inner">
            <div class="title">Chọn nhân viên</div>
            <div class="right"><a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a></div>
          </div>
        </div>
        <div class="page-content">
          <div class="list no-margin no-hairline">
            <ul>
              <li class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Lọc danh sách</div>
                  <div class="item-input-wrap input-dropdown-wrap">
                    <select name="filter-select">
                      <option value="">Xem tất cả</option>
                      <option value="is_reviewee">Cần được đánh giá</option>
                      <option value="is_reviewer">Là người đánh giá</option>
                      <option value="is_manager">Trưởng CH</option>
                    </select>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="list emp-list no-margin">
            <ul>
              ${rows.map(row=>$h`
                <li>
                  <a 
                    href="#" class="item-link item-content" 
                    data-id="${row.id}" 
                    data-name="${row.name}" 
                    data-is_reviewee="${row.is_reviewee || ''}" 
                    data-is_reviewer="${row.is_reviewer || ''}"
                    data-is_manager="${row.is_manager || ''}" 
                  >
                    <div class="item-inner">${row.name}</div>
                  </a>
                </li>
              `)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});